import { FC } from 'react';

import { ESHOP_TEST_ID } from '../../test/test-ids';
import { ProductCardSkeleton } from '../ProductCardSkeleton/ProductCardSkeleton';
import { ProductsCardsSkeletonWrapper } from './ProductsCardsSkeleton.styles';

export const ProductsCardsSkeleton: FC = () => (
    <ProductsCardsSkeletonWrapper data-test={ESHOP_TEST_ID.PRODUCTS_CARDS_SKELETON} aria-hidden="true">
        <ProductCardSkeleton />
        <ProductCardSkeleton />
    </ProductsCardsSkeletonWrapper>
);
